magna.closeModal = (event, el) => {
  if (event.target.classList.contains('overlay') || event.target.classList.contains('modal-close')) {
    document.querySelector('.modal').classList.remove('modal--open')
    document.body.removeChild(document.querySelector('.overlay'))
    document.body.removeChild(document.querySelector('.blur-background'))
    document.body.style.overflow = 'auto'
    el.addEventListener('click', magna.modal, { once: true })
  }
}

magna.modal = event => {
  const blurBackground = document.createElement('div')
  const overlay = document.createElement('div')
  const span = document.createElement('span')
  const target = event.currentTarget
  span.innerText = '×'
  span.classList.add('modal-close')
  blurBackground.setAttribute('class', 'blur-background')
  overlay.setAttribute('class', 'overlay')
  overlay.addEventListener('click', event => magna.closeModal(event, target))
  overlay.appendChild(span)

  document.body.prepend(blurBackground)
  document.body.prepend(overlay)

  blurBackground.classList.add('blur-background--open')
  overlay.classList.add('overlay--open')

  target.querySelector('.modal').classList.add('modal--open')
  document.body.style.overflow = 'hidden'
}
